export const SET_ACTION = "SET_ACTION";
export const SET_PAGE = "SET_PAGE";

export const SET_INDEX = "SET_INDEX";
export const DELETE_INDEX = "DELETE_INDEX";

export const SET_DELETE_QUEUE = "SET_DELETE_QUEUE";
export const UNDO_DELETE_QUEUE = "UNDO_DELETE_QUEUE";

export const RESET_APP_FORMS = "RESET_APP_FORMS";
export const SET_EDIT_ITEM = "SET_EDIT_ITEM";

export const RESET_FORM = "RESET_FORM";
export const ADD_FORM = "ADD_FORM";
export const UPDATE_FORM = "UPDATE_FORM";
export const UPDATE_FORM_STATUS = "UPDATE_FORM_STATUS";

export const RESET_ACCOUNTING = "RESET_ACCOUNTING";
export const UPDATE_ACCOUNTING = "UPDATE_ACCOUNTING";

export const RESET_FACTOR = "RESET_FACTOR";
export const UPDATE_FACTOR = "UPDATE_FACTOR";

export const RESET_TRANSACTION = "RESET_TRANSACTION";
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";

export const RESET_REMITTANCE = "RESET_REMITTANCE";
export const UPDATE_REMITTANCE = "UPDATE_REMITTANCE";

export const RESET_TRANSFER = "RESET_TRANSFER";
export const UPDATE_TRANSFER = "UPDATE_TRANSFER";

export const RESET_INSTALLMENT = "RESET_INSTALLMENT";
export const UPDATE_INSTALLMENT = "UPDATE_INSTALLMENT";

export const RESET_FORM_STATE = "RESET_FORM_STATE";
